const mobileGallery = () => {
  $('.mobile-gallery').slick({
    dots: true,
    arrows: false,
  });
};

export default mobileGallery;



// WEBPACK FOOTER //
// ./scripts/mobile-gallery.js